export default "__VITE_ASSET__BYPwgicH__"